import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import LayoutPageBlank from "@/components/templateux/layout/layout-page-blank";
import NavPrimary from "@/components/templateux/nav/nav-primary";
import Footer from "@/components/templateux/footer";
import { useSession } from "next-auth/client";
import { useSWRWrapper } from "@/lib/utils/hooks/swr-hooks";
import { config, meta } from "@/lib/config";
import SortHeader from "@/components/profile/sort-header";
import { PlayerContext } from "@/components/context/player-context";
import getRecordArray from "@/lib/utils/admin/server/record/getRecordArray";
import getMessage from "@/lib/utils/getMessage";
import { useUserAuth } from "@/lib/utils/hooks/useUserAuth";
import SvgJsx from "@/components/templateux/svg/svg-jsx";
import UsernameSearchModal from "@/components/settings/user/user-name/username-search-modal";
import { LayoutPageBlankContentWrapper } from "@/components/templateux/layout/layout-page-blank-content-wrapper";
import ProfileArrayInfinite from "@/components/profile/item/profile-array-infinite";
import getServerSideSecurity from "@/lib/utils/admin/server/getServerSideSecurity";

// This gets called at buildtime
export async function getServerSideProps(context) {
  //log the visit and return other relevant page / user data
  const { forbidden, user, ip, cookie, ssr_data_tribe } =
    await getServerSideSecurity(context);
  if (forbidden !== "") {
    context.res.write(forbidden);
    context.res.end();
  }

  const ssr_data = await getRecordArray(
    "user", //table_name: string
    "select_by_all_v2", //path_name: string
    "0", //user_id: string
    ssr_data_tribe?.tribe_id, //tribe_id: string
    "1", //page: string
    "broadcast", //sort: string
    "down", //config.itemdir //dir: string
    "" //filter: string
  );

  const navtype = "directory";
  const subnavtype = navtype;

  return {
    props: {
      ssr_data_tribe: ssr_data_tribe,
      ssr_data: ssr_data,
      params: context?.params || null,
      nodata: getMessage("noresults", ssr_data_tribe),
      navtype: navtype,
      subnavtype: navtype,
      helptype: "profile",
    },
    // ,revalidate: 300, // In seconds
  };
}

function Directory({
  ssr_data_tribe,
  ssr_data,
  params,
  nodata,
  navtype,
  subnavtype,
  helptype,
}) {
  const { player_state, set_player_state } = useContext(PlayerContext);

  //PRELOAD SSR DATA
  const [directoryarraydata_active, set_directoryarraydata_active] =
    useState(ssr_data);

  var user_name = "";
  const [session, loading] = useSession();
  const { userdata, isUserDataLoading, isUserDataError } = useUserAuth();
  const router = useRouter();
  const page = params?.page || router?.query?.page?.toString() || "1";
  const qfilter = "";
  const [filter, set_filter] = useState(qfilter);
  const [filterinput, set_filterinput] = useState(qfilter);
  const [filteropen, set_filteropen] = useState(false);
  const [sort, set_sort] = useState("broadcast");
  const cdir = "down"; //config.itemdir
  const [dir, set_dir] = useState(cdir);
  const [sortstr, set_sortstr] = useState(
    `${config.itemsort} ${config.itemdir}`
  );
  const [totalitems, set_totalitems] = useState(0);

  //search
  let [isOpen, set_isOpen] = useState(false);
  const [results, set_results] = useState(null);
  const [search, set_search] = useState("");

  function closeModal() {
    set_isOpen(false);
  }
  function openModal() {
    set_isOpen(true);
  }

  function doFilter(q) {
    set_filter(q);
    router.replace(`/directory?page=${1}&sort=${sort}&dir=${dir}&q=${q}`);
  }

  //FEATURED DATA
  const {
    data: directoryarraydata,
    loading: directoryarraydataisLoading,
    error: directoryarraydataisError,
    boundMutate: itemsMutate,
  } = useSWRWrapper(
    "0", //id
    `/api/private/user/select-by-all?page=${page}&sort=${sort}&dir=${dir}&q=${""}`, //key
    true, //retry?
    config.max_retries, //max number of retries
    config.retry_interval, //retry interval
    config.profile.stream_interval //refreshinterval (0=none)
  );

  //if (!loading && session) router.push(`/${session.user.all["user_name"]}/`)

  useEffect(() => {
    if (
      !directoryarraydataisLoading &&
      !directoryarraydataisError &&
      directoryarraydata
    ) {
      set_directoryarraydata_active(directoryarraydata);
    }
  }, [
    directoryarraydata,
    directoryarraydataisLoading,
    directoryarraydataisError,
  ]);

  return (
    <>
      {/* MAIN CONTAINER */}
      <LayoutPageBlank
        title={"Directory"}
        url={`${ssr_data_tribe?.server_website}/directory?page=${page}&sort=${sort}&dir=${dir}`}
        image={meta(ssr_data_tribe).image}
        ssr_data_tribe={ssr_data_tribe}
      >
        {/* <div onClick={()=>set_player('nugen')}>{player}</div> */}
        <NavPrimary
          userdata={userdata}
          isUserDataLoading={isUserDataLoading}
          isUserDataError={isUserDataError}
          navtype={"directory"}
          ssr_data_tribe={ssr_data_tribe}
        />
        <LayoutPageBlankContentWrapper>
          <div
            className={`border-b py-4 sticky top-12 z-100
                                    bg-gray-800 border-gray-700 px-4`}
          >
            <SortHeader
              headertitle={
                <>
                  <div className="flex items-center content-center">
                    <div className="flex-0">Broadcaster Directory</div>
                    <div className="flex-0 ml-2">
                      <div
                        className="hover:opacity-50 cursor-pointer"
                        onClick={() => {
                          set_isOpen(true);
                        }}
                      >
                        <SvgJsx
                          type="outline"
                          icon={"search"}
                          className={`h-8 w-8 `}
                          title={"Search"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              sort={sort}
              set_sort={set_sort}
              dir={dir}
              set_dir={set_dir}
              show_random={false}
              sortarray={[
                ["Broadcast", "broadcast", 1], //last one is direction
                ["Followers", "followers", 1], //last one is direction
                ["Join Date", "date", 1],
              ]}
            />
          </div>

          <div className=" w-full content-center item-center flex flex-col px-4">
            <ProfileArrayInfinite
              itemdata={directoryarraydata_active}
              isLoading={false} //{directoryarraydataisLoading}
              isError={false} //{directoryarraydataisError}
              userdata={userdata}
              ownerdata={ssr_data}
              placeholderdata={
                [
                  //   {
                  //    post_title: 'Loading'
                  //   ,crdate: +new Date().toISOString()
                  //   ,start_date: +new Date().toISOString()
                  //   ,end_date: +new Date().toISOString()
                  //   ,post_contents_json: []
                  //   ,bol_status: -1
                  //   ,bol_public: 0
                  //   ,bol_recording: 0
                  //   ,user_id: profiledata?.id
                  //   ,user_name: 'Lurker'
                  //   ,avatar_url: ''
                  //   ,post_id: -1
                  // }
                ]
              }
              nodata={nodata}
              navtype={subnavtype}
              helptype={helptype}
              swr_url={`/api/private/user/select-by-all?sort=${sort}&dir=${dir}&q=${""}`}
              sort={sort}
              dir={dir}
            />
          </div>
        </LayoutPageBlankContentWrapper>
        <Footer />
      </LayoutPageBlank>

      <UsernameSearchModal
        results={results}
        set_results={set_results}
        search={search}
        set_search={set_search}
        isOpen={isOpen}
        set_isOpen={set_isOpen}
        closeModal={closeModal}
        noresults={getMessage("noresults", ssr_data_tribe)}
        profiledata={null}
      />
    </>
  );
}

export default Directory;
